module.exports = __webpack_public_path__ + "static/media/perfil_pedro.5debee81.jpeg";